'use client'

export * from './WHeadingWrapper'
export * from './WTitleWrapper'
export * from './WParagraphWrapper'
export * from './WIconWrapper'
